<template>
  <details
    ref="details"
    :open="_open"
    :name="name"
    class="collapsable"
    data-testid="details"
    @toggle="toggleDetails"
  >
    <summary
      class="collapsable__label"
      data-testid="summary"
    >
      <slot
        name="label"
        :label="label"
        :open="_open"
      >
        <slot
          name="icon_before"
          :open="_open"
        />

        <component
          :is="props.headingTag"
          class="collapsable__heading"
        >
          {{ label }}
        </component>

        <slot
          name="icon_after"
          :open="_open"
        >
          <IconMin
            v-if="_open"
            class="collapsable__icon icon icon--min"
          />
          <IconPlus
            v-else
            class="collapsable__icon icon icon--plus"
          />
        </slot>
      </slot>
    </summary>
    <div
      class="collapsable__content"
      data-testid="content"
    >
      <slot>Details</slot>
    </div>
  </details>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  label?: string
  name?: string
  open?: boolean
  headingTag?: 'span' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}>(), {
  label: 'Summary',
  name: '',
  open: false,
  headingTag: 'span',
})

const { label, open } = toRefs(props)

const _open = ref(open.value)

const details = ref<HTMLDetailsElement | null>(null)
const toggleDetails = () => {
  _open.value = !!details.value?.open
}

watch(() => open, () => {
  _open.value = open.value
}, {
  immediate: true,
})

onMounted(() => {
  _open.value = open.value
})
</script>

<style>
@import url("~layers/app/components/Ui/Collapsable.css");
</style>
